import { render, staticRenderFns } from "./courseSelectCard.vue?vue&type=template&id=1915b312&scoped=true"
import script from "./courseSelectCard.vue?vue&type=script&lang=js"
export * from "./courseSelectCard.vue?vue&type=script&lang=js"
import style0 from "./courseSelectCard.vue?vue&type=style&index=0&id=1915b312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1915b312",
  null
  
)

export default component.exports